module.exports = __webpack_public_path__ + "static/media/vu_logo.c3fdf9ed.png";